import React from 'react';
import { Alert } from '@medely/ui-kit';
import { ShiftRequestStatus } from '@mp/graphql/generated/graphql';

enum Severity {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
}

type RateRequestStatus = Extract<
  ShiftRequestStatus,
  'pending' | 'approved' | 'declined' | 'auto_declined'
>;

interface RateRequestBannerProps {
  status: ShiftRequestStatus;
}

interface BannerProps {
  severity: Severity;
  title: string;
  description: string;
}

const BANNER_CONFIG: Record<RateRequestStatus, BannerProps> = {
  [ShiftRequestStatus.Pending]: {
    severity: Severity.INFO,
    title: 'Pending pay request',
    description: 'You will be notified if accepted.',
  },
  [ShiftRequestStatus.Approved]: {
    severity: Severity.SUCCESS,
    title: 'Pay request accepted',
    description: 'Book this shift now before it is released to another pro.',
  },
  [ShiftRequestStatus.Declined]: {
    severity: Severity.ERROR,
    title: 'Your pay request has been rejected',
    description: 'Please book at the suggested pay or submit another negotiation request.',
  },
  [ShiftRequestStatus.AutoDeclined]: {
    severity: Severity.ERROR,
    title: 'Your pay request has been rejected',
    description: 'Please book at the suggested pay or submit another negotiation request.',
  },
};

export const RateRequestBanner = ({ status }: RateRequestBannerProps) => {
  const availableStatuses = Object.keys(BANNER_CONFIG) as RateRequestStatus[];

  if (!availableStatuses.includes(status as RateRequestStatus)) {
    return null;
  }

  const { severity, title, description } = BANNER_CONFIG[status as RateRequestStatus];

  return (
    <Alert
      severity={severity}
      variant="filled"
      title={title}
      description={description}
      hideCloseIcon
    />
  );
};
